export default __webpack_public_path__ + "static/DSC_0454-c9461cbc6adb7e53f909fbf2427114bd.jpg";